import request from "@/utils/request";

export default {
  name: "RoomCalendar",
  data() {
    return {
      loading: false,
      days: 7,
      calendarData: [],
      totalCheckin: 0,
      totalCheckout: 0,
      avgStay: 0,
      detailVisible: false,
      detailTitle: '',
      detailData: [],
      selectedDay: null,
      // 选中日期后的房态面板数据
      roomPanelVisible: false,
      roomPanelData: []
    };
  },
  computed: {
    todayStr() {
      const d = new Date();
      return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
    },
    roomPanelDetail() {
      if (!this.selectedDay) return [];
      const rows = [];
      // 合并入住班级的房间和预订的房间
      (this.selectedDay.dayClasses || []).forEach(cls => {
        rows.push({
          dormroomId: cls.classId + '班房间',
          className: cls.className,
          classColor: cls.color,
          statusText: cls.enterDate === this.selectedDay.dateStr ? '入住' : (cls.leaveDate === this.selectedDay.dateStr ? '退房' : '在住'),
          statusType: cls.enterDate === this.selectedDay.dateStr ? 'success' : (cls.leaveDate === this.selectedDay.dateStr ? 'danger' : ''),
          enterDate: cls.enterDate,
          leaveDate: cls.leaveDate
        });
      });
      (this.selectedDay.dayBookings || []).forEach(b => {
        rows.push({
          dormroomId: b.dormroomId,
          className: b.className,
          classColor: b.classColor,
          statusText: b.checkInDate === this.selectedDay.dateStr ? '入住' : (b.checkOutDate === this.selectedDay.dateStr ? '退房' : '预订在住'),
          statusType: b.checkInDate === this.selectedDay.dateStr ? 'success' : (b.checkOutDate === this.selectedDay.dateStr ? 'danger' : 'warning'),
          enterDate: b.checkInDate,
          leaveDate: b.checkOutDate
        });
      });
      return rows;
    }
  },
  created() {
    this.loadCalendar();
  },
  methods: {
    loadCalendar() {
      this.loading = true;
      request.get("/roomCalendar/data", {
        params: { days: this.days }
      }).then((res) => {
        if (res.code === "0") {
          this.calendarData = res.data.calendarDays || [];
          this.totalCheckin = res.data.totalCheckin || 0;
          this.totalCheckout = res.data.totalCheckout || 0;
          this.avgStay = res.data.avgStay || 0;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    viewDetail(row) {
      this.selectedDay = row;
      this.detailTitle = row.dateStr + ' ' + row.weekDay + ' 房态详情';
      // 构建详情数据：入住班级 + 预订班级 + 退房班级
      const detailRows = [];
      // 当日在住班级
      (row.dayClasses || []).forEach(cls => {
        // 判断今日是否是入住日或退房日
        let status = 'staying';
        if (cls.enterDate === row.dateStr) status = 'checkIn';
        if (cls.leaveDate === row.dateStr) status = 'checkOut';
        detailRows.push({
          className: cls.className,
          color: cls.color,
          studentCount: cls.studentCount,
          enterDate: cls.enterDate,
          leaveDate: cls.leaveDate,
          status,
          type: 'class'
        });
      });
      // 当日预订
      (row.dayBookings || []).forEach(b => {
        let status = 'staying';
        if (b.checkInDate === row.dateStr) status = 'checkIn';
        if (b.checkOutDate === row.dateStr) status = 'checkOut';
        detailRows.push({
          className: b.className,
          color: b.classColor,
          dormroomId: b.dormroomId,
          bedsCount: b.bedsCount,
          checkInDate: b.checkInDate,
          checkOutDate: b.checkOutDate,
          status,
          type: 'booking'
        });
      });
      this.detailData = detailRows;
      this.detailVisible = true;
    },
    // 点击某日展开房态直观图
    viewRoomPanel(row) {
      this.selectedDay = row;
      this.roomPanelVisible = true;
      this.roomPanelData = row;
    },
    getStatusTag(status) {
      if (status === 'checkIn') return '入住';
      if (status === 'checkOut') return '退房';
      return '在住';
    },
    getStatusType(status) {
      if (status === 'checkIn') return 'success';
      if (status === 'checkOut') return 'danger';
      return 'primary';
    },
    downloadTemplate() {
      // 下载日历数据为 Excel
      request.get("/execl/exportCalendar", {
        params: { days: this.days },
        responseType: 'blob'
      }).then((res) => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const now = new Date();
        link.download = '房态日历' + now.getFullYear() + String(now.getMonth()+1).padStart(2,'0') + String(now.getDate()).padStart(2,'0') + '.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(() => {});
    }
  }
};
